import { Injectable } from "@angular/core";
import { AbstractParser } from "../../parser";
import { CompanyContact } from "src/app/ui/models/domains/pbm/companies/company-contact";
import { parseCompanyContactList } from "./company-parse-functions";

@Injectable()
export class ContactParser extends AbstractParser<Array<CompanyContact>> {
  parse(payload: any): CompanyContact[] {
    return parseCompanyContactList(payload);
  }
}
